import { observable, computed, asStructure } from "mobx";
import debounce from "lodash.debounce";
import history from "history-events";

export default class UiState {
  windowDimensions = {
    width: 375,
    height: 667
  };
  scroll = observable({
    top: 0,
    pageYOffset: 0,
    scrolling: false
  });
  location = observable({
    pathname: "INTIAL"
  });

  constructor() {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", debounce(this.handleScroll, 15));
      window.addEventListener("popstate", this.handleUrlChange);
      window.addEventListener("changestate", this.handleUrlChange);
    }
  }

  handleUrlChange = () => {
    const pathname = window.location.pathname;
    if (this.location.pathname !== pathname) {
      this.location.pathname = pathname;
    }
  };
  handleScroll = () => {
    setTimeout(() => {
      if (window.scrollY === this.scroll.top) {
        this.scroll.scrolling = false;
      }
    }, 250);
    this.scroll.top = window.scrollY;
    this.scroll.pageYOffset = window.pageYOffset;
    this.scroll.scrolling = true;
  };
}



// WEBPACK FOOTER //
// ./src/store/ui.js